import { isAmazon, readAmazon } from './amazon';
import type { SiteFindings } from './types';

export type { SiteFindings } from './types';

/**
 * The one place that knows a shop by name.
 *
 * Kept to a lookup so that adding a shop is adding a file, and so the generic
 * pipeline never has to grow an `if (hostname === …)`.
 */
export function readSite(doc: Document, finalUrl: string): SiteFindings | undefined {
  let hostname: string;
  try {
    hostname = new URL(finalUrl).hostname;
  } catch {
    return undefined;
  }

  if (isAmazon(hostname)) return readAmazon(doc, hostname);
  return undefined;
}
